export default "__VITE_ASSET__FNQro6fP__"